import { useTranslation } from 'react-i18next';
import { FormScreenHeader } from './FormScreenHeader';
import { InputField } from '@web/utils/src';
import { AddressValidationInput } from '@/components/AddressValidationInput';
import { useFormContext } from '../FormContext';

export const AddressScreen = () => {
  const { t } = useTranslation();
  const {
    form,
    inputHandler,
    register,
    errors,
    formDetails,
    currentStage,
    handleStageChange,
    setCoordinates,
  } = useFormContext();

  return (
    <div role="addresses-screen">
      <FormScreenHeader
        title={t('create_user_modal.add_your_address')}
        handleStageChange={handleStageChange}
      />
      <AddressValidationInput
        setValue={inputHandler}
        setCoordinates={setCoordinates}
      />
      <div className="mt-2-0 grid grid-cols-1 gap-2-0">
        {formDetails[currentStage].map((item) => (
          <InputField
            formValues={form}
            item={item}
            register={register}
            key={item.id}
            errors={errors}
            inputHandler={inputHandler}
            t={t}
          />
        ))}
      </div>
    </div>
  );
};
export default AddressScreen;
